import { render, staticRenderFns } from "./DataDictionaryEdit.vue?vue&type=template&id=00509dae&scoped=true"
import script from "./DataDictionaryEdit.vue?vue&type=script&lang=js"
export * from "./DataDictionaryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00509dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00509dae')) {
      api.createRecord('00509dae', component.options)
    } else {
      api.reload('00509dae', component.options)
    }
    module.hot.accept("./DataDictionaryEdit.vue?vue&type=template&id=00509dae&scoped=true", function () {
      api.rerender('00509dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/dataDictionary/DataDictionaryEdit.vue"
export default component.exports